import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { TranslateContext } from 'core/translate';
import { SvgIcon } from 'core/icons';
import OptionCheckbox from './OptionCheckbox';
import OptionMsrpHeader from './OptionMsrpHeader';
import { useModelInfo } from '../ModelInfoContext';

const getTruckFeaturedDimension = (translate, features, id) => {
  const FEATURE_ID = 351;
  const styleId = _.get(
    _.find(features.options, { bodyTypeId: id }),
    'styleId'
  );
  const value = features.styleIds[styleId].Dimensions[FEATURE_ID];
  return {
    label: translate('dimensions.bed.length'),
    value: value
  };
};

const getVanFeaturedDimension = (features, id) => {
  const CARGO_FEATURE_ID = 371;
  const PASSENGER_FEATURE_ID = 372;
  const styleId = _.get(
    _.find(features.options, { bodyTypeId: id }),
    'styleId'
  );
  const dimensionGroups = features.groups.Dimensions;
  const styleDimensions = features.styleIds[styleId].Dimensions;
  const featureId = dimensionGroups[PASSENGER_FEATURE_ID]
    ? PASSENGER_FEATURE_ID
    : CARGO_FEATURE_ID;
  return {
    label: dimensionGroups[featureId].description,
    value: styleDimensions[featureId]
  };
};

const getFeaturedDimension = (translate, features, featureGroup, id) => {
  if (!features) {
    return;
  }

  switch (featureGroup) {
    case 'truck':
      return getTruckFeaturedDimension(translate, features, id);
    case 'van':
      return getVanFeaturedDimension(features, id);
    default:
      return;
  }
};

const DimensionsLink = ({ id, features, featureGroup, country }) => {
  const isCanada = country === 'CA';
  return (
    <TranslateContext.Consumer>
      {translate => {
        let dimension;

        try {
          dimension = getFeaturedDimension(
            translate,
            features,
            featureGroup,
            id
          );
        } catch (e) {
          return null;
        }

        if (!dimension) {
          return null;
        }

        const { label, value } = dimension;

        return (
          <Link
            to={`/config/dimensions/${id}`}
            className="config-option__featured-dimension">
            <div className="config-option__featured-dimension-text">
              <span>{isCanada ? `${label} : ` : `${label}: `}</span>
              <span className="config-option__featured-dimension-value">
                {value}
              </span>
            </div>
            <div>
              <SvgIcon name="info" />
            </div>
          </Link>
        );
      }}
    </TranslateContext.Consumer>
  );
};

const BodyTypeOption = props => {
  const {
    option,
    disabled,
    disclaimer,
    analyticsKey,
    features,
    featureGroup,
    onChange
  } = props;
  const {
    id,
    selected,
    conflict,
    formattedConfig: description,
    lowestMSRP: msrp,
    icon,
    iconClass,
    rearWheelType
  } = option;

  const onSelect = () => {
    if (!disabled && !selected) {
      onChange(option);
    }
  };

  const modelInfo = useModelInfo();
  const { country } = modelInfo;

  return (
    <div className="option">
      <OptionMsrpHeader
        msrp={msrp}
        disclaimer={disclaimer}
        analyticsKey={analyticsKey}
        analyticsKey2={description}
      />
      <div className="option__row">
        <div>
          <OptionCheckbox
            id={id}
            onChange={onSelect}
            checked={selected}
            conflict={conflict}
            disabled={disabled}
            analyticsKey={analyticsKey}
            analyticsKey2={description}
          />
        </div>
        {icon ? (
          <div
            className={`option__selectable ${
              selected ? 'option__selectable--disabled' : ''
            } stat-checkbox`}
            data-dtm={analyticsKey}
            data-dtm2={description}
            onClick={onSelect}>
            <SvgIcon
              name={icon}
              className={`config-option__image ${iconClass || ''}`}
            />
          </div>
        ) : null}
        <div
          className={`option__column config-option__content ${
            selected ? 'option__selectable--disabled' : ''
          }`}>
          <div onClick={onSelect} className="option__selectable">
            <div>{description}</div>
            <div>{rearWheelType}</div>
          </div>
          <DimensionsLink
            id={id}
            features={features}
            featureGroup={featureGroup}
            country={country}
          />
        </div>
      </div>
    </div>
  );
};

export default BodyTypeOption;
